import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { PRODUCT_TO_TREE_CONSTRAINTS } from './constraints.js';
// Shared by linkProductToTree and unlinkProductToTree -- both take the same
// { productId, productTreeId } shape, matching customerBrandInputSchema's link/unlink reuse.
export const productToTreeInputSchema = z.object({
    productId: requiredUuidString(`${PRODUCT_TO_TREE_CONSTRAINTS.productId.label} is required.`, `Invalid ${PRODUCT_TO_TREE_CONSTRAINTS.productId.label.toLowerCase()} selection.`),
    productTreeId: requiredUuidString(`${PRODUCT_TO_TREE_CONSTRAINTS.productTreeId.label} is required.`, `Invalid ${PRODUCT_TO_TREE_CONSTRAINTS.productTreeId.label.toLowerCase()} selection.`),
});
//# sourceMappingURL=input.js.map